import { render, staticRenderFns } from "./ShipReviewTrendAnalysis.vue?vue&type=template&id=02de841a&"
import script from "./ShipReviewTrendAnalysis.vue?vue&type=script&lang=js&"
export * from "./ShipReviewTrendAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports